/* ── Testimonials Slider ── */
(function () {
  function initSlider(el) {
    const track  = el.querySelector('[data-lf-track]');
    const prev   = el.querySelector('[data-lf-prev]');
    const next   = el.querySelector('[data-lf-next]');
    const dotsEl = el.querySelector('[data-lf-dots]');
    if (!track) return;

    const slides = track.querySelectorAll('.lf-testimonials__slide');
    let current  = 0;

    function perView() {
      if (window.innerWidth >= 990) return 3;
      if (window.innerWidth >= 750) return 2;
      return 1;
    }

    function maxIndex() {
      return Math.max(0, slides.length - perView());
    }

    function buildDots() {
      if (!dotsEl) return;
      dotsEl.innerHTML = '';
      for (let i = 0; i <= maxIndex(); i++) {
        const btn = document.createElement('button');
        btn.className = 'lf-testimonials__dot' + (i === current ? ' is-active' : '');
        btn.setAttribute('aria-label', `${(window.lfStrings || {}).slide || 'Slide'} ${i + 1}`);
        btn.addEventListener('click', () => go(i));
        dotsEl.appendChild(btn);
      }
    }

    function go(idx) {
      current = Math.max(0, Math.min(idx, maxIndex()));
      const pct = (100 / perView()) * current;
      track.style.transform = `translateX(-${pct}%)`;
      dotsEl?.querySelectorAll('.lf-testimonials__dot').forEach((d, i) => {
        d.classList.toggle('is-active', i === current);
      });
    }

    prev?.addEventListener('click', () => go(current - 1));
    next?.addEventListener('click', () => go(current + 1));

    buildDots();
    window.addEventListener('resize', () => { buildDots(); go(0); });
  }

  function init() {
    document.querySelectorAll('[data-lf-testimonials-slider]').forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
